import { useState, useEffect } from 'react';
/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../../sidebar/sidebar.css";


const API_URL = process.env.REACT_APP_API_URL;


const VRMSidebar = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['tprm_custom_questionnaire']);
  const [isHovered, setIsHovered] = useState(false);


  useEffect(() => {
    const $ = window.$;

    $('.sidebar').off('click.treeview').on('click.treeview', '.has-treeview > a', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Prevent double trigger
      e.stopPropagation(); // Also stop bubbling

      const parent = $(this).parent();
      const submenu = parent.find('> .nav-treeview');

      const isOpen = parent.hasClass('menu-open');

      if (isOpen) {
        // Close the current
        parent.removeClass('menu-open menu-is-opening');
        submenu.css('display', 'none');
      } else {
        // Close all others
        $('.has-treeview.menu-open')
          .not(parent)
          .removeClass('menu-open menu-is-opening')
          .find('> .nav-treeview')
          .css('display', 'none');

        // Open current
        parent.addClass('menu-open menu-is-opening');
        submenu.css('display', 'block');
      }
    });

    return () => {
      $('.sidebar').off('click.treeview');
    };
  }, []);

  const handleLogout = async () => {
    try {
      // Get username from localStorage BEFORE clearing it
      const username = localStorage.getItem("username");

      // Call backend logout API with username
      const response = await axios.post(`${API_URL}api/logout/`, { username }, { withCredentials: true });
      const message = response.data?.message || "Logged out successfully.";
      toast.success(message, { autoClose: 2000 });

      // Clear user data from local storage or global state
      localStorage.removeItem('user');
      localStorage.removeItem("userRole");
      localStorage.removeItem("username");
      localStorage.removeItem("user_id");
      localStorage.removeItem("role");
      localStorage.removeItem("email");
      localStorage.removeItem("first_name");
      localStorage.removeItem("last_name");

      setTimeout(() => {
        navigate('/vrm_login');
      }, 500);
    } catch (error) {
      console.error("Logout Error:", error);
      toast.error(error.response?.data?.message || "Logout failed. Please try again.", { autoClose: 3000 });
    }
  };
  const [user, setUser] = useState(null); // Store user data

  useEffect(() => {
    // Fetch logged-in user details
    axios
      .get(`${API_URL}api/user-details/`, { withCredentials: true }) // Adjust API URL as needed
      .then((response) => {
        setUser(response.data); // Store user details in state
      })
      .catch((error) => {
        console.error("Error fetching user details:", error);
      });
  }, []);

  // Search functionality
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const $ = window.$;
    // Search functionality - filter menu items
    const searchValue = searchTerm.toLowerCase().trim();
    if (searchValue) {
      // Find and scroll to matching menu items (including those in collapsed submenus)
      const menuItems = document.querySelectorAll('.nav-link p, .nav-link');
      let foundMatch = false;
      let firstMatch = null;

      menuItems.forEach((item) => {
        const text = item.textContent?.toLowerCase() || '';
        if (text.includes(searchValue)) {
          const navItem = item.closest('.nav-item');
          if (navItem) {
            // Check if this item is inside a collapsed submenu
            const parentTreeview = navItem.closest('.has-treeview');
            if (parentTreeview && !parentTreeview.classList.contains('menu-open')) {
              // Use jQuery to expand the parent menu (same as manual expansion)
              const $parent = $(parentTreeview);
              const $submenu = $parent.find('> .nav-treeview');

              // Close all other open menus first (like manual expansion does)
              $('.has-treeview.menu-open').not($parent)
                .removeClass('menu-open menu-is-opening')
                .find('> .nav-treeview')
                .css('display', 'none');

              // Open the current menu
              $parent.addClass('menu-open menu-is-opening');
              $submenu.css('display', 'block');
            }

            // Store first match for scrolling
            if (!foundMatch) {
              firstMatch = navItem;
            }

            foundMatch = true;
          }
        }
      });

      if (foundMatch && firstMatch) {
        // Scroll to the first match after menu expansion
        setTimeout(() => {
          const sidebar = document.querySelector('.sidebar');
          if (sidebar && firstMatch) {
            const itemTop = firstMatch.offsetTop;
            const sidebarScrollTop = sidebar.scrollTop;
            const sidebarHeight = sidebar.clientHeight;

            // Calculate scroll position to center the item
            const scrollTo = itemTop - (sidebarHeight / 2) + (firstMatch.offsetHeight / 2);

            // Smooth scroll the sidebar container instead of using scrollIntoView
            sidebar.scrollTo({
              top: scrollTo,
              behavior: 'smooth'
            });

            // Highlight the matching item
            firstMatch.classList.add('highlight-search');
            setTimeout(() => {
              firstMatch.classList.remove('highlight-search');
            }, 2000);
          }
        }, 150); // Wait for menu expansion animation
      } else if (!foundMatch) {
        // Optional: Show a message if no matches found
        console.log('No matches found');
      }
    }
  };

  return (
    <div onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      {/* Main Sidebar Container */}
      <aside id="mainSidebar" className="main-sidebar sidebar-dark-primary elevation-4" data-bs-theme="dark">
        {/* Brand Logo Section */}
        {/* Brand Logo Section */}
        <Link to="/vrm_dashboard" className="d-flex align-items-center m-3">
          <img
            src={isHovered ? "../img/cyberinsurify_logo.png" : "../img/cyberinsurify-logo-small.png"}
            alt="CyberInsurify logo"
            className={`logo-small brand-image ${isHovered ? "hovered" : ""}`}
          />
          <span className="brand-text font-weight-light">

            <img
              src={isHovered ? "../img/cyberinsurify_logo.png" : "../img/cyberinsurify_logo.png"}
              alt="CyberInsurify brand"
              className="brand-logo ml-4"
            />
          </span>

        </Link>
        {/* Brand Name */}
        <h6 className="fw-300 ml-2" >VRM 2.0</h6>

        {/* Sidebar */}
        <div className="sidebar sidebar-font">
          {/* Sidebar user panel (optional) */}

          {/* SidebarSearch Form */}

          {/* Sidebar Menu */}
          <nav className="mt-2">
            {/* Search Bar Section */}
            <form onSubmit={handleSearch} className="input-group mb-3 sidebar-search">
              <input
                type="text"
                className="form-control search-input"
                placeholder="Search..."
                aria-label="Sidebar search"
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <div className="input-group-append">
                <button
                  className="btn btn-outline-secondary square-btn"
                  type="submit"
                  aria-label="Search"
                >
                  <i
                    className="fas fa-search"
                  ></i>
                </button>

              </div>
            </form>
            <ul className="nav nav-pills nav-sidebar flex-column text-left" data-widget="treeview" role="menu" data-accordion="false">
              {/* Add icons to the links using the .nav-icon class
         with font-awesome or any other icon font library */}

              <li className="nav-item has-treeview">
                <Link to="#" className="nav-link active">
                  <img src="../img/dashboard-icon.png" alt="Dashboard icon" style={{ width: "20px", height: "20px" }} className='me-2' />
                  <p>
                    Dashboard and Reports
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>

                <ul className="nav nav-treeview">

                  <li className="nav-item">
                    <Link to="/vrm_portfolio_dashboard" className="nav-link">
                      <img src="../img/sub-icon.png" alt="Portfolio dashboard icon" className='sub-icon me-2' />
                      <p>Portfolio Dashboard</p>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link to="/vrm_client_dashboard" className="nav-link">
                      <img src="../img/sub-icon.png" alt="Sub menu icon" className='sub-icon me-2' />
                      <p>Client Dashboard</p>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link to="/vrm_dashboard" className="nav-link" target="_blank" rel="noopener noreferrer">
                      <img src="../img/sub-icon.png" alt="Dashboard sub icon" className='sub-icon me-2' />
                      <p>My Dashboard</p>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link to="/vrm_time_logs" className="nav-link">
                      <img src="../img/sub-icon.png" alt="Time Logs sub icon" className='sub-icon me-2' />
                      <p>Time Logs</p>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link to="/vrm_recommendations" className="nav-link">
                      <img src="../img/sub-icon.png" alt="Recommendations icon" className='sub-icon me-2' />
                      <p>Recommendation Register</p>
                    </Link>
                  </li>

                </ul>
              </li>

              {/* Client Workspace */}
              <li className="nav-item has-treeview">
                <Link to="#" className="nav-link">
                  <img src="../img/virtual-risk-icon.svg" alt="Client workspace icon" style={{ width: "20px", height: "20px" }} className='me-2' />
                  <p>
                    Client Workspace
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>

                <ul className="nav nav-treeview">

                  <li className="nav-item">
                    <Link to="/vrm_client_workspace" className="nav-link">
                      <img src="../img/sub-icon.png" alt="Client workspace icon" className='sub-icon me-2' />
                      <p>Assigned Client Workspace</p>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link to="/vrm_client_success_plan" className="nav-link">
                      <img src="../img/sub-icon.png" alt="Client success plan icon" className='sub-icon me-2' />
                      <p>Client Success Plan</p>
                    </Link>
                  </li>

                </ul>
              </li>

              {/* Client Request */}
              <li className="nav-item has-treeview">
                <Link to="#" className="nav-link">
                  <img src="../img/risk-management.png" alt="Client request icon" style={{ width: "20px", height: "20px" }} className='me-2' />
                  <p>
                    Client Request
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>

                <ul className="nav nav-treeview">

                  <li className="nav-item">
                    <Link to="/vrm_risk_register_requests" className="nav-link">
                      <img src="../img/sub-icon.png" alt="Risk register requests icon" className='sub-icon me-2' />
                      <p>Risk Register Requests</p>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link to="/vrm_questionnaire_requests" className="nav-link">
                      <img src="../img/sub-icon.png" alt="Questionnaire requests icon" className='sub-icon me-2' />
                      <p>TPRM Questionnaire Requests</p>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link to="/vrm_custom_questionnaires" className="nav-link">
                      <img src="../img/sub-icon.png" alt="" className='sub-icon me-2' />
                      <p>{t('vrm.menu')}</p>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link to="/vrm_audit_checklist_requests" className="nav-link">
                      <img src="../img/sub-icon.png" alt="Audit checklist requests icon" className='sub-icon me-2' />
                      <p>Audit Checklist Requests</p>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link to="/vrm_audit_buddy_requests" className="nav-link">
                      <img src="../img/sub-icon.png" alt="Audit buddy requests icon" className='sub-icon me-2' />
                      <p>Audit Buddy Requests</p>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link to="/vrm_framework_requests" className="nav-link">
                      <img src="../img/sub-icon.png" alt="Framework requests icon" className='sub-icon me-2' />
                      <p>Framework Requests</p>
                    </Link>
                  </li>

                </ul>
              </li>





              {/*Request management */}
              <li className="nav-item">
                <Link to="/request_management" className="nav-link" style={{ color: 'white' }}>
                  <img src="../img/risk-management.png" alt="Risk management icon" style={{ width: "20px", height: "20px" }} className='me-2' />
                  <p>
                    Request Management

                  </p>
                </Link>
              </li>


              {/* Risk Management */}



              {/* <li className="nav-item">
                <Link to="/archived_frameworks" className="nav-link" style={{ color: 'white' }}>
                  <img src="../img/sub-icon.png" alt="Archived frameworks icon" style={{ height: 14, width: 14 }} className="me-2" />
                  <p>Archived Frameworks</p>
                </Link>
              </li> */}

              {/*  Ask the Expert */}
              <li className="nav-item">
                <Link to="/ask_the_expert" className="nav-link" style={{ color: 'white' }}>
                  <span className="sidebar-icons">
                    <img src="../img/ask-expert-icon.png" alt="Ask the expert icon" style={{ height: 20, width: 20 }} className="icon-style me-2" />
                  </span>
                  <p>Ask the Expert</p>
                </Link>
              </li>

              {/*  Email Support */}
              {/* <li className="nav-item">
                <a href="./email_support" className="nav-link" style={{ color: 'white' }}>
                  <span className="sidebar-icons">
                    <img src="../img/envelope-icon.svg" style={{ height: 20, width: 20 }} className="icon-style me-2" />
                  </span>
                  <p>Email Support</p>
                </a>
              </li> */}

              {/* CHANGED: match the CARA Feedback & Suggestions submenu for VRM users. */}
              <li className="nav-item has-treeview">
                <Link to="#" className="nav-link" style={{ color: 'white' }}>
                  <span className="sidebar-icons">
                    <img src="../img/feedback-icon.png" alt="Feedback icon" style={{ height: 20, width: 20 }} className="icon-style me-2" />
                  </span>
                  <p>
                    Feedback & Suggestions
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link to="/submit_feedback" className="nav-link" style={{ color: 'white' }}>
                      <img src="../img/sub-icon.png" alt="Submit feedback" className="sub-icon me-2" />
                      <p>Submit Feedback</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/my_feedback" className="nav-link" style={{ color: 'white' }}>
                      <img src="../img/sub-icon.png" alt="My feedback" className="sub-icon me-2" />
                      <p>My Feedback</p>
                    </Link>
                  </li>
                </ul>
              </li>

              {/* CHANGED: VRM uses the same external CARA resource destination as CARA Admin. */}
              <li className="nav-item has-treeview">
                <Link to="#" className="nav-link" style={{ color: 'white' }}>
                  <img src="/img/resources-icon.svg" alt="Resources icon" style={{ height: 20, width: 20 }} className="icon-style me-2" />
                  <p>
                    Resources
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <a
                      href="https://caragrc.com/blog/"
                      className="nav-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="../img/sub-icon.png" alt="Resource sub icon" className='sub-icon me-2' />
                      <p>CARA Blog</p>
                    </a>
                  </li>
                </ul>
              </li>

              {/*  My Settings */}
              <li className="nav-item has-treeview">
                <Link to="#" className="nav-link" style={{ color: 'white' }}>
                  <span className="sidebar-icons">
                    <img src="../img/settings-icon.svg" alt="Settings icon" style={{ height: 20, width: 20 }} className="icon-style me-2" />
                  </span>
                  <p>
                    My Settings
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link to="/privacy" className="nav-link">
                      <img src="../img/sub-icon.png" alt="Privacy icon" className='sub-icon me-2' />
                      <p>Privacy</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/profile" className="nav-link">
                      <img src="../img/sub-icon.png" alt="Profile icon" className='sub-icon me-2' />
                      <p>Profile</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/vrm_audit_trails" className="nav-link">
                      <img src="../img/sub-icon.png" alt="Audit trails icon" className='sub-icon me-2' />
                      <p>Audit Trails</p>
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Logout Section */}
              <li className="nav-item mb-3">
                <button
                  className="nav-link d-flex align-items-center"
                  style={{ color: 'white', background: 'none', border: 'none', cursor: 'pointer' }}
                  onClick={handleLogout}
                >
                  <span className="sidebar-icons">
                    <img
                      src="../img/logout-icon.png"
                      style={{ height: 20, width: 20 }}
                      className="icon-style me-2"
                      alt="Logout icon"
                    />
                  </span>
                  <p className="mb-0">
                    Logout
                    {user && (
                      <span style={{ fontWeight: 'bold', color: '#88FF99', marginLeft: '5px' }}>
                        {user.first_name} {user.last_name}
                      </span>
                    )}
                  </p>
                </button>
              </li>
            </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        {/* /.sidebar */}
      </aside>
    </div>
  );
}

export default VRMSidebar;
